module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9684b10804a422e28712aa058933bd7a.png";